<template>
    <div>
    </div>
</template>

<script>
    

    export default {
        name: "OpenMarketExistingRegistrationRedirectPage",

        data() {
            return {

            }
        },

        created() {
            let search = window.location.search
            this.doRedirect(search);
        },

        methods: {
            doRedirect(search) {
                this.$router.push("/open-market/existing-registration" + search)
            },
        },
    }
</script>

<style scoped>

</style>